export const localStorageKeys = {
    userId: "TC-userId",
    email: "TC-email",
    accessToken: "TC-accessToken",
    isActivate: "TC-isActivate"
}
